import { useMutation } from "@tanstack/react-query";
import TenantHandler from "../handlers/tenant";

const useGetPartnerList = (onSuccess, onFailure) => {
    const tenantHandler = new TenantHandler();

    const { data, isPending, isSuccess, isError, error, mutate } = useMutation({
        mutationFn: () => tenantHandler.getPartnerList(),
        mutationKey: ["get_partner_list"],
        onSuccess: onSuccess,
        onError: onFailure,
    });

    return { data, isPending, isSuccess, isError, error, mutate };
};

export default useGetPartnerList;
